// IE 2026 09 20 / ODOO-… (замечание Игоря со скринами: закрыл виджет графика — окно его легенды осталось на странице; «проверь везде и для графа, для бабл …
// чтобы и легенды закрывались вместе с виджетом либо при переходе на другую вкладку виджета, к которой она не относится»).
// Окна легенд (график, пузырьки, карта, граф, потоки) телепортируются в контейнер страницы и живут ВНЕ DOM своего виджета, а закрытие виджета «мягкое»
// (display: none, компонент смонтирован ещё 5 минут — store.widget_close), смена вкладки прячет холст, но не окно. Общее правило показа окна:
//   виджет открыт (не закрыт и не закрыт «мягко») И (холст владельца виден ИЛИ открыта вкладка, к которой легенда ОТНОСИТСЯ).
// Относится — панель полей (doc.viewList) того же виджета у графика и пузырьков: ⚙ строки легенды ведёт туда, стрелка легенды — к строке поля
// (ODOO-5800, 14.09). Закрытие виджета сбрасывает и признак «легенда открыта» — заново открытый виджет приходит без окна легенды, как новый.
// Выключатель: fe.ux.legendFollowsOwner = false — прежнее поведение.

export function legendOwner_widgetOpen(WIDGET) {
    return !!WIDGET && !WIDGET.close && !WIDGET._softClosed
}

// вкладка панели полей (грид doc.viewList) этого виджета сейчас на экране
export function legendOwner_fieldsTabShown(WIDGET) {
    try {
        for (const c of Object.values(WIDGET?.attrs_vueObj || {})) {
            if (c?.attr?.binding !== 'doc.viewList') continue
            const host = c.flex?.hostElement
            if (host && host.offsetParent) return true
        }
    } catch (e) { /* виджет разбирается */ }
    return false
}

// Примесь владельца окна легенды. Компонент даёт: legendOwner_flagOn() — признак «легенда открыта», legendOwner_close() — закрыть её,
// legendOwner_related() — есть ли у легенды «своя» вкладка кроме холста (панель полей); сообщает видимость холста: legendOwner_onVisible(isVisible)
// (директива v-visible) и добавляет legendOwner_shown() в условие показа окна.
export const legendOwnerMixin = {
    data() {
        return { legendOwnerVisible: true, legendRelatedShown: false }
    },
    methods: {
        legendOwner_on() {
            try { return this.store?.setting?.('fe.ux.legendFollowsOwner', true) !== false } catch (e) { return true }
        },
        legendOwner_shown() {
            if (!this.legendOwner_on()) return true
            return legendOwner_widgetOpen(this.WIDGET) && (this.legendOwnerVisible || this.legendRelatedShown)
        },
        legendOwner_onVisible(isVisible) {
            this.legendOwnerVisible = !!isVisible
            this.legendOwner_poll()
        },
        // холст скрыт, а легенда открыта: следим (250 мс), открыта ли «своя» вкладка; следилка живёт только в этом состоянии
        legendOwner_poll() {
            clearInterval(this._legendOwnerTimer); this._legendOwnerTimer = null
            const need = () => this.legendOwner_on() && !this.legendOwnerVisible && !!this.legendOwner_related?.() && !!this.legendOwner_flagOn?.() && legendOwner_widgetOpen(this.WIDGET)
            if (!need()) { if (this.legendRelatedShown) this.legendRelatedShown = false; return }
            const tick = () => {
                if (!need()) { this.legendOwner_poll(); return }
                const v = legendOwner_fieldsTabShown(this.WIDGET)
                if (this.legendRelatedShown !== v) this.legendRelatedShown = v
            }
            tick()
            this._legendOwnerTimer = setInterval(tick, 250)
        },
    },
    watch: {
        // виджет закрыт («мягко») — окно легенды закрывается вместе с ним, признак «легенда открыта» сбрасывается
        'WIDGET._softClosed'(v) {
            if (!v || !this.legendOwner_on()) return
            try { this.legendOwner_close?.() } catch (e) { /* владелец разбирается */ }
            this.legendOwner_poll()
        },
    },
    beforeUnmount() {
        clearInterval(this._legendOwnerTimer); this._legendOwnerTimer = null
    },
}
